import * as React from "react";
type Props = {
  className?: string,
};
function SvgDullLightBulb({ className }: Props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-DullLightBulb"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9583 10.5685C10.71 10.7597 10.5448 11.0463 10.5448 11.3597V11.9393C10.5448 12.274 10.2735 12.5454 9.93874 12.5454H5.69632C5.3616 12.5454 5.09026 12.274 5.09026 11.9393V11.3597C5.09026 11.0463 4.92508 10.7597 4.6768 10.5685C3.45393 9.62656 2.66602 8.14768 2.66602 6.48477C2.66602 3.63966 4.97243 1.33325 7.81753 1.33325C10.6626 1.33325 12.969 3.63966 12.969 6.48477C12.969 8.14768 12.1811 9.62656 10.9583 10.5685ZM11.7569 6.48477C11.7569 7.7777 11.2519 8.8282 10.2418 9.63628C9.63571 10.0807 9.33268 10.6464 9.33268 11.3333H6.30238C6.30238 10.6464 5.99935 10.0807 5.39329 9.63628C4.38319 8.8282 3.87814 7.7777 3.87814 6.48477C3.87814 5.39386 4.26197 4.46457 5.02965 3.69689C5.79733 2.92921 6.72662 2.54537 7.81753 2.54537C8.90844 2.54537 9.83773 2.92921 10.6054 3.69689C11.3731 4.46457 11.7569 5.39386 11.7569 6.48477ZM5.09026 14.0605C5.09026 13.7258 5.3616 13.4545 5.69632 13.4545H9.93874C10.2735 13.4545 10.5448 13.7258 10.5448 14.0605C10.5448 14.3952 10.2735 14.6666 9.93874 14.6666H5.69632C5.3616 14.6666 5.09026 14.3952 5.09026 14.0605ZM9.83912 5.58665C9.94863 5.90295 10.2101 6.18174 10.5448 6.18174C10.8795 6.18174 11.1572 5.90766 11.091 5.57955C10.851 4.38907 9.91323 3.4513 8.72275 3.21127C8.39464 3.14511 8.12056 3.42278 8.12056 3.75749C8.12056 4.09221 8.39935 4.35367 8.71565 4.46317C9.2411 4.64509 9.6572 5.0612 9.83912 5.58665Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgDullLightBulb;
